















































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import {cloneDeep} from "lodash"
import Search from "@/components/UI/Search.vue";
import ICheckbox from '@/components/icons/ICheckbox.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')
const surveys = namespace('surveys')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    Search,
    'i-checkbox': ICheckbox,
  },
  name: "ChangeIncludeQuestionForm"
})
export default class ChangeIncludeQuestionForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options: any
  @surveys.Getter('survey') protected survey: any

  search: string = ''
  selectQuestions: any = []
  questions: any = []

  mounted() {
    this.questions = cloneDeep(this.survey.questions)
    this.checkIncludeQuestions(this.options.currentQuestion.id)
  }

  @Watch('fullDialogShow')
  checkQuestions() {
    if (this.fullDialogShow) {
      this.questions = cloneDeep(this.survey.questions)
      this.checkIncludeQuestions(this.options.currentQuestion.id)
    }
  }

  @Watch('fullDialogShow')
  setSelectQuestions() {
    if (this.fullDialogShow) {
      this.selectQuestions = []
      this.options.answer.includeQuestions.forEach((includeQuestion: any) => {
        this.selectQuestions.push(includeQuestion)
      })
    }
  }

  get searchQuestions() {
    return this.questions.filter((question: any) => {
      return question.text.toLowerCase().includes(this.search.toLowerCase().trim())
          && question.id != this.options.currentQuestion.id
          && question.type != 'text_container'
          && !this.options.answer.includeQuestions.map((el:any) => {
            return el.id
          }).includes(question.id)
    })
  }

  checkIncludeQuestions(id: string) {
    this.questions.forEach((question: any) => {
      question.answers.forEach((answer: any) => {
        answer.includeQuestions.forEach((include: any) => {
          if (include.id == id) {
            let index = this.questions.findIndex((q: any) => q.id === question.id)
            if (index != -1) this.questions.splice(index, 1)
            question.answers.forEach((answer: any) => {
              answer.includeQuestions.forEach((includeQuestion: any) => {
                let includeIndex = this.questions.findIndex((q: any) => q.id === includeQuestion.id)
                if (includeIndex != -1) this.questions.splice(includeIndex, 1)
              })
            })
            if (question.include) this.checkIncludeQuestions(question.id)
          }
        })
      })
    })
  }

  changeSelect(question: any) {
    if (this.selectQuestions.indexOf(question.id) != -1) {
      this.selectQuestions = this.selectQuestions.filter((q: any) => q != question.id)
      question.include = false
    } else {
      this.selectQuestions.push(question.id)
    }
  }

  save() {
    this.options.answer.includeQuestions = this.selectQuestions
    this.SetFullDialogShow(false)
  }


}
